import React from 'react';
import tick from '../assets/mark.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const LeftSubHeader = () => {


  







  return (
    <div className="left-sub-header-container">
      <div className="left-sub-header-header">
        A healthier path to weight loss, fitness, and overall wellness.
      </div>
      <div className="left-sub-header-benefits-container">
        <div className="left-sub-header-benefit-container">
          <div className="left-sub-header-benefit-tick-container">
            <img
              src={tick}
              alt="mark or tick"
              className="left-sub-header-benefit-tick"
            />
          </div>
          <div className="left-sub-header-benefit-text">
            Nutrient Dense Meals.
          </div>
        </div>
        <div className="left-sub-header-benefit-container">
          <div className="left-sub-header-benefit-tick-container">
            <img
              src={tick}
              alt="mark or tick"
              className="left-sub-header-benefit-tick"
            />
          </div>
          <div className="left-sub-header-benefit-text">
            Daily Home Workout.
          </div>
        </div>
        <div className="left-sub-header-benefit-container">
          <div className="left-sub-header-benefit-tick-container">
            <img
              src={tick}
              alt="mark or tick"
              className="left-sub-header-benefit-tick"
            />
          </div>
          <div className="left-sub-header-benefit-text">
            Intermittent fasting period.
          </div>
        </div>
        <div className="left-sub-header-benefit-container">
          <div className="left-sub-header-benefit-tick-container">
            <img
              src={tick}
              alt="mark or tick"
              className="left-sub-header-benefit-tick"
            />
          </div>
          <div className="left-sub-header-benefit-text">Portion control.</div>
        </div>
      </div>
      <div className="left-sub-header-get-on-device-container">
        <Link to={'/'} className="left-sub-header-get-on-device">
          <FontAwesomeIcon
            icon={faGooglePlay}
            className="left-sub-header-get-on-device-icon"
          />
          <p className="left-sub-header-get-on-device-text">Get on Andriod</p>
        </Link>
        <Link to={'/'} className="left-sub-header-get-on-device">
          <FontAwesomeIcon
            icon={faApple}
            className="left-sub-header-get-on-device-icon"
          />
          <p className="left-sub-header-get-on-device-text">Get on IOS</p>
        </Link>
      </div>
    </div>
  );
};

export default LeftSubHeader;
